module.exports = __webpack_public_path__ + "img/case-bg.61fb1584.png";